window.Subscriber = window.Subscriber || {};

window.subscribe = function subscribe(eventName, callback) {
  if (!window.Subscriber[eventName]) {
    window.Subscriber[eventName] = [];
  }

  window.Subscriber[eventName].push(callback);

  return function unsubscribe() {
    window.Subscriber[eventName] = window.Subscriber[eventName].filter((subscriber) => subscriber !== callback);
  };
};

window.publish = function publish(eventName, data) {
  if (!window.Subscriber[eventName]) return;
  window.Subscriber[eventName].forEach((callback) => callback(data));
};
